export default __webpack_public_path__ + "static/media/kr.63e3a1d2.svg";